import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/mobile/fi-rr-angle-small-right.svg'
import _imports_1 from '@/assets/images/mobile/payali-icon.png'
import _imports_2 from '@/assets/images/mobile/USDT3.png'
import _imports_3 from '@/assets/images/mobile/clock-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-30fdd3f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content content-points-details" }
const _hoisted_2 = { class: "mx-auto fw-medium pe-0 pl-20" }
const _hoisted_3 = { class: "d-flex p-3 rounded-3 total-preview-section flex-wrap" }
const _hoisted_4 = { class: "me-3" }
const _hoisted_5 = { class: "m-0 fs-13-custom" }
const _hoisted_6 = { class: "text-white cashable fs-28-custom d-flex align-items-center flex-wrap" }
const _hoisted_7 = { class: "text-white mb-0 me-2" }
const _hoisted_8 = { class: "fs-13-custom ps-2 mt-2" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "m-0 fs-13-custom" }
const _hoisted_11 = { class: "text-white cumulative-withdrawal fs-28-custom" }
const _hoisted_12 = { class: "mt-3 input-cash-section bg-white rounded-3 p-3" }
const _hoisted_13 = { class: "py-2 fs-20-custom text-black" }
const _hoisted_14 = { class: "input-group bg-white fs-28-custom align-items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 fw-semibold text-black" }, "￥", -1))
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = {
  key: 0,
  class: "mb-0 error-message-youan fs-11-custom"
}
const _hoisted_18 = { class: "d-flex justify-content-between p-3 py-2 show-info-input mt-2 fs-13-custom bg-gray-withdraw" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "" }
const _hoisted_24 = { class: "account-info-section bg-white mt-3 rounded-3 p-3" }
const _hoisted_25 = { class: "py-2 fs-20-custom text-black" }
const _hoisted_26 = { class: "account-container bg-white" }
const _hoisted_27 = { class: "bg-gray-withdraw d-flex align-items-center p-3 flex-wrap rounded-top-3" }
const _hoisted_28 = {
  key: 0,
  class: "me-2",
  src: _imports_1,
  alt: ""
}
const _hoisted_29 = {
  key: 1,
  class: "me-2",
  src: _imports_2,
  alt: ""
}
const _hoisted_30 = { class: "me-2 text-black" }
const _hoisted_31 = { class: "mb-0 fs-11-custom me-2 fee rounded-1" }
const _hoisted_32 = { class: "bg-gray-withdraw fs-15-custom p-3" }
const _hoisted_33 = { class: "mb-0" }
const _hoisted_34 = ["placeholder"]
const _hoisted_35 = { class: "mb-0" }
const _hoisted_36 = ["placeholder"]
const _hoisted_37 = { class: "mb-0" }
const _hoisted_38 = ["placeholder"]
const _hoisted_39 = { class: "bg-gray-withdraw d-flex align-items-start p-3 rounded-bottom-3" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "clock-icon me-2 mt-1",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_41 = { class: "fs-15-custom time-note" }
const _hoisted_42 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mask_layer = _resolveComponent("mask-layer")!
  const _component_Fade = _resolveComponent("Fade")!
  const _component_change_account_dialog = _resolveComponent("change-account-dialog")!
  const _component_confirm_data_dialog = _resolveComponent("confirm-data-dialog")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_error_tips = _resolveComponent("error-tips")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["container-mobile bg-points-details overflow-auto", [$setup.state.isfocusTextArea?'increase-h':'']])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["header d-flex text-black px-3 custom-fs-18 container-390 position-fixed align-items-center justify-content-between", [$setup.getAgentType===1?'pth-android':$setup.getAgentType===2? 'pth-ios':'']])
        }, [
          _createElementVNode("img", {
            role: "button",
            src: _imports_0,
            alt: "back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.BackToMyPoints()))
          }),
          _createElementVNode("div", _hoisted_2, _toDisplayString($setup.local.withdraw_1), 1),
          _createElementVNode("div", {
            role: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goToWithdrawnHistory())),
            class: "pe-0 withdraw-records-btn"
          }, _toDisplayString($setup.local.withdraw_2), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["content-all-points px-3", [$setup.getAgentType===1?'ptc-android':$setup.getAgentType===2? 'ptc-ios':'']])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString($setup.local.withdraw_3), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString($setup.availablePurchasePointsYuan), 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString($setup.availableCashablePoints) + " " + _toDisplayString($setup.local.withdraw_5), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString($setup.local.withdraw_4), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString($setup.withdrawnYuan), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString($setup.local.withdraw_6), 1),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.cashInput) = $event)),
                type: "text",
                class: "border-0 fw-semibold ms-2 flex-grow-1",
                onInput: _cache[3] || (_cache[3] = ($event: any) => ($setup.isNumber($setup.data.cashInput))),
                placeholder: $setup.local.withdraw_9
              }, null, 40, _hoisted_16), [
                [
                  _vModelText,
                  $setup.data.cashInput,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            ($setup.data.errorMessageInputCash)
              ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString($setup.data.errorMessageInputCash), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_19, _toDisplayString($setup.local.withdraw_7), 1),
                _createElementVNode("p", _hoisted_20, _toDisplayString($setup.local.withdraw_8), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("p", _hoisted_22, _toDisplayString($setup.data.transferParam * Number($setup.data.cashInput)), 1),
                _createElementVNode("p", _hoisted_23, _toDisplayString($setup.data.transferParam), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, _toDisplayString($setup.local.withdraw_10), 1),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                ($setup.state.isAliPay)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_28))
                  : (_openBlock(), _createElementBlock("img", _hoisted_29)),
                _createElementVNode("div", _hoisted_30, _toDisplayString($setup.state.isAliPay ? $setup.local.withdraw_11 : 'USDT'), 1),
                _createElementVNode("p", _hoisted_31, _toDisplayString($setup.state.isAliPay ? $setup.local.withdraw_12 :
                                $setup.local.withdraw_30), 1),
                _createElementVNode("button", {
                  class: "ms-auto fs-13-custom change-btn border-0 rounded-4 p-1 px-3",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openComponent('showChangeDialog')))
                }, _toDisplayString($setup.local.withdraw_13), 1),
                _withDirectives(_createElementVNode("p", { class: "fs-11-custom fee-note-usdt mb-0 ms-4 mt-1" }, _toDisplayString($setup.local.withdraw_20) + " +0.2", 513), [
                  [_vShow, !$setup.state.isAliPay]
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["input-group align-items-center", [$setup.isEN ? 'in-group-en' : '']])
                }, [
                  _createElementVNode("p", _hoisted_33, _toDisplayString($setup.local.withdraw_14), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    ref: "textarea1",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.alipayAccount) = $event)),
                    type: "text",
                    class: "border-0 flex-grow-1",
                    placeholder: $setup.local.withdraw_15,
                    onInput: _cache[6] || (_cache[6] = ($event: any) => {$setup.autoResize($setup.textarea1); $setup.isAccount()}),
                    onFocus: _cache[7] || (_cache[7] = ($event: any) => ($setup.textareaIsFocus())),
                    onBlur: _cache[8] || (_cache[8] = ($event: any) => ($setup.textareaIsFocus()))
                  }, null, 40, _hoisted_34), [
                    [
                      _vModelText,
                      $setup.data.alipayAccount,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ], 2), [
                  [_vShow, $setup.state.isAliPay]
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["input-group align-items-center", [$setup.isEN ? 'in-group-en' : '']])
                }, [
                  _createElementVNode("p", _hoisted_35, _toDisplayString($setup.local.withdraw_16), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    ref: "textarea2",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.data.realName) = $event)),
                    type: "text",
                    class: "border-0 flex-grow-1",
                    placeholder: $setup.local.withdraw_17,
                    onInput: _cache[10] || (_cache[10] = ($event: any) => ($setup.autoResize($setup.textarea2))),
                    onFocus: _cache[11] || (_cache[11] = ($event: any) => ($setup.textareaIsFocus())),
                    onBlur: _cache[12] || (_cache[12] = ($event: any) => ($setup.textareaIsFocus()))
                  }, null, 40, _hoisted_36), [
                    [
                      _vModelText,
                      $setup.data.realName,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ], 2), [
                  [_vShow, $setup.state.isAliPay]
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["input-group align-items-center", [$setup.isEN ? 'in-group-en' : '']])
                }, [
                  _createElementVNode("p", _hoisted_37, _toDisplayString($setup.local.withdraw_21), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    ref: "textarea3",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.data.usdtAddress) = $event)),
                    type: "text",
                    class: "border-0 flex-grow-1",
                    placeholder: $setup.local.withdraw_22,
                    onInput: _cache[14] || (_cache[14] = ($event: any) => {$setup.autoResize($setup.textarea3); $setup.isAddress()}),
                    onFocus: _cache[15] || (_cache[15] = ($event: any) => ($setup.textareaIsFocus())),
                    onBlur: _cache[16] || (_cache[16] = ($event: any) => ($setup.textareaIsFocus()))
                  }, null, 40, _hoisted_38), [
                    [
                      _vModelText,
                      $setup.data.usdtAddress,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ], 2), [
                  [_vShow, !$setup.state.isAliPay]
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, _toDisplayString($setup.local.withdraw_18), 1)
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: _normalizeClass(["submit-btn border-0 rounded-5 p-2 my-3", [$setup.state.isSubmitActive ? 'active-submit-btn' : '']]),
            disabled: !$setup.state.isSubmitActive,
            onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.openComponent('showConfirmDialog')))
          }, _toDisplayString($setup.local.withdraw_19), 11, _hoisted_42)
        ], 2)
      ]),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_mask_layer, null, null, 512), [
            [_vShow, $setup.state.showLoading || $setup.state.showChangeDialog || $setup.state.showConfirmDialog]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_change_account_dialog, {
            onHide: _cache[18] || (_cache[18] = ($event: any) => ($setup.closeComponent('showChangeDialog'))),
            onChange: _cache[19] || (_cache[19] = (method) => $setup.changeMethodType(method))
          }, null, 512), [
            [_vShow, $setup.state.showChangeDialog]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_confirm_data_dialog, {
            onHide: _cache[20] || (_cache[20] = ($event: any) => ($setup.closeComponent('showConfirmDialog'))),
            onSubmit: _cache[21] || (_cache[21] = ($event: any) => ($setup.submitRequest())),
            amount: $setup.data.cashInput,
            account: $setup.data.alipayAccount,
            fullname: $setup.data.realName,
            address: $setup.data.usdtAddress,
            isAlipay: $setup.state.isAliPay
          }, null, 8, ["amount", "account", "fullname", "address", "isAlipay"]), [
            [_vShow, $setup.state.showConfirmDialog]
          ])
        ]),
        _: 1
      })
    ], 2),
    _withDirectives(_createVNode(_component_Spinner, null, null, 512), [
      [_vShow, $setup.state.showLoading]
    ]),
    _createVNode(_component_error_tips, { ref: "errorRef" }, null, 512)
  ], 64))
}